// extracted by mini-css-extract-plugin
export default {"outer":"User_outer__LQrEv","wrapper":"User_wrapper__QFaMu","block":"User_block__czBgu"};